export default __webpack_public_path__ + "static/media/Directory.0c3563cb.svg";